import { Component, Inject } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DeviceDetectorService } from "ngx-device-detector";
import { AbstractBiditComponent } from "../../shared/controls/abstract.bidit.component";
import { ChangeOrder } from "../../shared/models/change.order.interface";
import { JobService } from "../services/job.service";

export interface ChangeOrderDialogData {
  changeOrder: ChangeOrder;
}

@Component({
  selector: 'change.order.dialog',
  templateUrl: 'change.order.dialog.html',
})
export class ChangeOrderDialog extends AbstractBiditComponent {

  constructor(
    deviceDetectorService: DeviceDetectorService,
    private jobService: JobService,
    public dialogRef: MatDialogRef<ChangeOrderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeOrderDialogData) {
    super(deviceDetectorService);
  }

  saveChangeOrder(form: NgForm): void {
    if (form.valid) {
      this.isRequesting = true;

      this.jobService.updateChangeOrder(this.data.changeOrder)
        .subscribe(
          {next:(data) => this.dialogRef.close(data),
          error: (error: string) => this.onError(error)});
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
